// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
export const noop = (...args: any[]) => {};



// WEBPACK FOOTER //
// ./src/shared/helpers/noop.ts